module.exports = __webpack_public_path__ + "img/m_home.86a9b2da.png";